import { render } from "./SurveyGroup.vue?vue&type=template&id=692851ef"
import script from "./SurveyGroup.vue?vue&type=script&lang=js"
export * from "./SurveyGroup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thanaphon/Documents/LTC/ltc-poc-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__